var AR = {
	//Язык страницы (en, ru)
	lang: $('html').attr('lang'),
	//Высота окна
	windowHeight: $(window).height(),
	//Ширина окна
	windowWidth: $(window).width()
};

/**
 * Локализованый текст
 * @param  {Object} textObj Текст на нескольких языках в формате {ru: 'русский', en: 'english'}
 * @return {String} Строка на текущем языке
 */
AR.locale = function (textObj) {
	return textObj[AR.lang];
};

//Заголовок годового отчёта
AR.title = AR.locale({
	ru: 'Годовой отчёт 2015',
	en: 'Annual report 2015'
});

//Переопределяем высоту и ширину окна по resize
$(window).on('resize', function () {
	AR.windowHeight = $(window).height();
	AR.windowWidth = $(window).width();
});

global.AR = AR;

module.exports = AR;

require('./imageLoad.js');
require('./blurOnLeave.js');
require('./links.js');



/** WEBPACK FOOTER **
 ** ./frontend/components/core/core.js
 **/